import { useEffect, useRef, useState } from "react";

interface UseScrollDetectionReturn {
  isScrollingUp: boolean;
  isViewingHistory: boolean;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
}

export function useScrollDetection(
  threshold: number = 100,
): UseScrollDetectionReturn {
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [isViewingHistory, setIsViewingHistory] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const lastScrollTop = useRef(0);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleScroll = () => {
      const currentScrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      const distanceFromBottom = scrollHeight - clientHeight - currentScrollTop;

      const scrollingUp = currentScrollTop < lastScrollTop.current;
      setIsScrollingUp(scrollingUp);

      const viewingHistory = distanceFromBottom > threshold;
      setIsViewingHistory(viewingHistory);

      lastScrollTop.current = currentScrollTop;
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [threshold]);

  return {
    isScrollingUp,
    isViewingHistory,
    scrollContainerRef,
  };
}
